import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { ApiError } from "../config/CustomErrors";

export const usePlanFeatureFlags = (
  reactQueryOptions: UseQueryOptions<unknown, ApiError, unknown, string> = {},
) => useQuery(internalApi.planFeatureFlags.show(), reactQueryOptions);
